import React from 'react';

export default function HeadphonesSVG() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="105" height="106" viewBox="0 0 105 106">
      <g fill="none" fillRule="nonzero">
        <path
          fill="#9DD7F9"
          d="M52.896 0C74.68 0 92.339 17.45 92.339 38.974c0 2.405-.22 4.759-.642 7.044h-6.788c.509-2.268.777-4.625.777-7.044 0-17.894-14.68-32.4-32.79-32.4s-32.79 14.506-32.79 32.4c0 2.419.268 4.776.776 7.044h-6.787a38.747 38.747 0 0 1-.643-7.044C13.452 17.449 31.112 0 52.896 0z"
        />
        <g transform="rotate(-15 327.953 -151.275)">
          <path
            fill="#9DD7F9"
            d="M40.246.018c0 14.522-11.773 26.295-26.296 26.295-.952 0-1.892-.05-2.818-.149V19.54c.92.131 1.861.2 2.818.2 10.892 0 19.722-8.83 19.722-19.722h6.574z"
          />
          <ellipse cx="8.315" cy="22.557" fill="#3791DF" rx="7.513" ry="5.635" />
        </g>
        <path
          fill="#4EB7F5"
          d="M13.76 42.14c.67-1.253 1.614-2.127 2.832-2.621a24.955 24.955 0 0 1 3.434-1.136l1.104 8.212-6.739.24-.631-4.696zM92.032 42.14c-.67-1.253-1.615-2.127-2.832-2.621a24.955 24.955 0 0 0-3.435-1.136l-1.104 8.212 6.739.24.632-4.696z"
          opacity=".3"
        />
        <g transform="rotate(-180 52.896 38.974)">
          <path fill="#9DD7F9" d="M9.048 28.17a8.452 8.452 0 0 1 .253-16.9v16.904z" />
          <path
            fill="#C4E7FC"
            d="M21.862 36.623c-9.7-.17-17.508-7.671-17.508-16.901 0-9.336 7.989-16.905 17.844-16.905v33.81z"
          />
          <path fill="#D8EFFD" d="M21.438 22.54v11.269l-.33-.004c-7.267-.142-13.264-4.96-14.473-11.265h14.803z" />
          <rect width="5.635" height="39.443" x="20.722" fill="#75C7F7" rx="2.817" />
        </g>
        <g transform="translate(0 38.504)">
          <path fill="#9DD7F9" d="M9.048 28.17a8.452 8.452 0 0 1 .253-16.9v16.904z" />
          <path
            fill="#C4E7FC"
            d="M21.862 36.623c-9.7-.17-17.508-7.671-17.508-16.901 0-9.336 7.989-16.905 17.844-16.905v33.81z"
          />
          <path fill="#D8EFFD" d="M21.438 16.904V5.634l-.33.004c-7.267.142-13.264 4.96-14.473 11.266h14.803z" />
          <rect width="5.635" height="39.443" x="20.722" fill="#75C7F7" rx="2.817" />
        </g>
      </g>
    </svg>
  );
}
